import { usePost } from './useHttpHooks.ts';
import {
    CitationInfo,
    FileSearchResult,
    ThreadMessage
} from '../components/knowledge/types.ts';

interface ThreadHistoryRequest {
    threadId: string;
    files: FileSearchResult[];
}

interface ThreadHistoryResponse {
    messages: ThreadMessage[];
    files: CitationInfo[];
}

const usePostThreadHistory = () =>
    usePost<ThreadHistoryRequest, ThreadHistoryResponse>(
        '/api/knowledge-assistant/threads/history',
        {
            errorMessage: 'POST /api/knowledge-assistant/history'
        }
    );

export default usePostThreadHistory;
